<template>
    <div class="share-icon-outer">
        <i class="iconfont icon-share"></i>
    </div>
</template>

<script>
  export default {
    name: 'shareBtn'
  };
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/variable";
.share-icon-outer {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    position: fixed;
    right: 10px;
    bottom: 140px;
    background-color: #ffffff;
    box-shadow: 0px 0px 10px #c5c5c5;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    &:hover {
        background-color: $themeColor;
        .icon-share {
            color: #ffffff;
        }
    }
    .icon-share {
        font-size: 30px;
        color: $themeColor;
    }
}
</style>
